// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"204":"f72f9c60","245":"8a2e32c7","272":"fdaed82b","375":"47dbfcd0","473":"c8481e6a"}[chunkId] + ".chunk.css";
};